export enum ConditionalOperator {
  EQUALS = 'equals',
  NOT_EQUALS = 'not_equals',
  GREATER_THAN = 'greater_than',
  LESS_THAN = 'less_than',
  GREATER_THAN_OR_EQUAL = 'greater_than_or_equal',
  HAS_VALUE = 'has_value',
  IS_EMPTY = 'is_empty',
}

export interface ShowWhenConfig {
  fieldKey: string;
  operator: ConditionalOperator;
  value?: any;
}
